var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('BillingMonth'),_c('BilletPaymentDash')],1),_c('div',{staticClass:"row"},[_c('BillingServiceDash'),_c('BillingDayDash')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }